<template>
  <div :class="{'salary-settings-container': isInSchoolSalarySettings}">
    <Loader v-if="isLoadingSalaryCodes" :bg-color="isInSchoolSalarySettings ? '#edf0f5' : '#fff'"></Loader>
    <table class="do-table do-table--striped do-table--fixed" v-else>
      <thead>
      <th class="td-loenart">Lønart</th>
      <th class="td-tillaegsnummer">Tillægsnummer</th>
      <th class="td-navn">
        <div class="th-text-and-button">
          Navn
          <button class="do-bttn do-bttn--submit" @click="setIsCreateItemModal(true)">
            Opret ny lønkode
          </button>
        </div>
      </th>
      </thead>
      <tbody>
      <tr v-if="items.length === 0">
        <td colspan="3">
          <i>Ingen oprettet</i>
        </td>
      </tr>
      <tr v-for="item in items" :key="item.code">
        <td class="td-loenart">{{ item.code }}</td>
        <td class="td-tillaegsnummer">{{ item.tillaegsnummer ? item.tillaegsnummer : '' }}</td>
        <td class="td-navn">{{ item.name }}</td>
      </tr>
      </tbody>
    </table>
    <TableCreateModal
      v-if="isCreateItemModal"
      :theType="'lønkoder'"
      :theEditItem="theEditItem"
      :isSubmitting="isSubmitting"
      :isDeleting="isDeleting"
      :salarySystem="salarySystem"
      :submitError="submitError"
      @close="setIsCreateItemModal"
      @onSubmit="onCreate">
    </TableCreateModal>
  </div>
</template>

<script>
import TableCreateModal from './TableCreateModal.vue'
import docendo from '../../../docendo'
import Loader from '../../common/Loader.vue'

export default {
  components: {Loader, TableCreateModal},
  props: {
    isInSchoolSalarySettings: {
      default: true
    }
  },
  data () {
    return {
      isCreateItemModal: false,
      theEditItem: null,
      isSubmitting: false,
      isDeleting: false,
      tillaegsnummer: '',
      submitError: ''
    }
  },
  computed: {
    schoolId () {
      return this.$store.getters.schoolId
    },
    salarySystem () {
      return this.$store.getters.salarySystem
    },
    items () {
      return this.salaryCodes
    },
    salaryCodes () {
      return this.$store.getters.salaryCodesSorted
    },
    isLoadingSalaryCodes () {
      return this.$store.state.employments.isLoadingSalaryCodes
    }
  },
  methods: {
    setIsCreateItemModal (bool) {
      this.isCreateItemModal = bool
      this.submitError = ''
      if (!bool) {
        this.theEditItem = null
      }
    },
    setEditItem (item) {
      this.theEditItem = item
      this.isCreateItemModal = true
    },
    onCreate (obj) {
      const schoolId = this.schoolId
      const name = obj.name
      const loenart = obj.code
      const tillaegsnummer = obj.tillaegsnummer ? obj.tillaegsnummer : ''
      this.isSubmitting = true
      this.submitError = ''
      docendo.createSalaryCode(schoolId, name, loenart, tillaegsnummer, success => {
        this.isCreateItemModal = false
        this.isSubmitting = false
        this.$store.dispatch('readSalaryCodes')
      }, failure => {
        this.isSubmitting = false
        this.submitError = this.translateSalaryCodeError(failure)
      })
    },
    // Oversætter kendte valideringsfejl fra backend (app/models/salary/code.rb) til dansk.
    // Dialogen forbliver åben, så brugeren kan rette og prøve igen.
    translateSalaryCodeError (failure) {
      const raw = failure && failure.error ? String(failure.error) : (typeof failure === 'string' ? failure : '')
      const known = [
        {match: 'must be three digits', text: 'Lønart skal være præcis 3 cifre.'},
        {match: 'must be six digits', text: 'Tillægsnummer skal være 6 cifre eller tomt.'},
        {match: 'must be one digit', text: 'Tillægsnummer skal være 1 ciffer eller tomt.'}
      ]
      const messages = known.filter(k => raw.indexOf(k.match) > -1).map(k => k.text)
      if (messages.length > 0) {
        return messages.join(' ')
      }
      console.error('Kunne ikke oprette lønkode', failure)
      return 'Lønkoden kunne ikke oprettes. Prøv igen, eller kontakt support hvis fejlen fortsætter.'
    }
  },
  mounted () {
    this.$store.dispatch('readSalaryCodes')
  }
}
</script>

<style scoped>
.salary-settings-container {
  padding: 1rem;
  max-width: 1440px;
  width: 100%;
}

.do-table--fixed {
  table-layout: auto; /* sørger for naturlig tilpasning */
}

.do-table--fixed th.td-navn,
.do-table--fixed td.td-navn {
  width: 80%;
}

.do-table__items tbody tr:nth-child(2n) {
  background-color: #f9fafb;
}

.do-table__items tbody tr {
  border-bottom: 1px solid #eee;
}

.do-table__items tr:hover {
  background-color: aliceblue !important;
}

.do-table__items th:last-child {
  text-align: right;
}

.do-table__items tr > td:last-child {
  display: flex;
  justify-content: flex-end;
}

.th-text-and-button {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// SalaryCodes.vue?98abf200